import styled from '@emotion/styled'
import { colors } from 'Constants'

export default styled.div`
  display: contents;

  > * {
    padding: 8px;
    align-self: center;

    ${({ border }) =>
      border && `border-bottom: 1px solid ${colors.borderColor};`}
  }
`
